let apiUrl = 'http://localhost:8000/student';

if(process.env.REACT_APP_ENV === 'staging') {
  apiUrl = 'https://test.otoschool.fr:8088/student';
}

export default apiUrl;